Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = findRouteComponent;

var _exposeMetrics = require("./exposeMetrics");

function findRouteComponent() {
    var routes = (0, _exposeMetrics.getMountedInstances)();
    var component = routes && routes.length > 0 && routes[routes.length - 1];
    return component;
}


//////////////////
// WEBPACK FOOTER
// ../~/react-metrics/lib/react/findRouteComponent.js
// module id = 1555
// module chunks = 0